import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { Hub } from '../../../components';
import { CaptionText, H2, P1, P2, P3 } from '../../../styles/FontStyles';
import { Button, Flexed } from '../../../styles/GlobalComponents';
import { PurchaseSteps } from '../Maeketplace.types';

interface PaymentMethodProps {
  setStep: Dispatch<SetStateAction<PurchaseSteps>>;
  selectedPackage: any;
  selectedLicence: any;
  checkedLicence: boolean;
}

export const PaymentMethod = ({
  setStep,
  selectedPackage,
  selectedLicence,
  checkedLicence
}: PaymentMethodProps) => {
  const { t } = useTranslation('marketplace');

  if (!selectedPackage?.id) return null;

  const amountToPay = selectedLicence
    ? selectedPackage?.subscriptionPrice
      ? selectedLicence.price +
        selectedPackage?.price +
        selectedPackage?.subscriptionPrice
      : selectedLicence.price + selectedPackage?.price
    : selectedPackage?.subscriptionPrice
    ? selectedPackage?.subscriptionPrice + selectedPackage?.price
    : selectedPackage?.price;

  return (
    <div>
      <P1 bold mb={'20'}>
        {t('selected_staking_hub_nft')}:
      </P1>

      <Hub
        key={selectedPackage?.id}
        condensed
        image={selectedPackage?.imageUrl}
        title={selectedPackage?.name}
        price={checkedLicence ? amountToPay : selectedPackage?.price}
        subscriptionPrice={selectedPackage?.subscriptionPrice}
        selectedLicence={selectedLicence}
        subtitle={selectedPackage?.subtitle}
        tickets={selectedPackage?.tickets}
        packagePrice={selectedPackage?.price}
        weeklyCap={selectedPackage?.weeklyCap}
        limitedQuantity={selectedPackage?.limitedQuantity}
        dobuleTradingBinaries={selectedPackage?.tradingBinaryPercentage}
        includesSubscription={checkedLicence}
        willyMemeCoins={selectedPackage?.willyMemeCoins}
        info={<></>}
      />

      <P2 mb={'20'} mt={'40'}>
        {t('technology_of_the_future')}
      </P2>

      {/* MIXED PAYMENT */}
      {/* <Button mb={20} onClick={() => setStep(PurchaseSteps.PAY_MIXED)}>
        {showButtonText()}
      </Button> */}
      {/* MIXED PAYMENT */}

      <Button
        mb={20}
        onClick={() => {
          setStep(PurchaseSteps.PAY_TETHER);

          // setUsdt(amountToPay.toString());
        }}>
        {t('pay_with_tether')}
      </Button>
    </div>
  );
};
